export function convertPrice(price,quote) {
  if (price < 0 || price === null || price === undefined || price === '') {
      // 유효하지 않은 값일 경우, 빈 문자열 반환
      // return '$0';
      if(quote == "USDT"){
          return "$0"
      }else {
          return "₩0"
      }
  }
  let stringValue = price.toString();
  if(quote == "USDT"){
      if (!stringValue.startsWith('$')) {
          if (stringValue.indexOf('.') !== -1) {
              stringValue = stringValue.replace(/0+$/, '');
              stringValue = stringValue.replace(/\.$/, '');
          }
      }
      // console.log('stringValue',stringValue);
      return `$${stringValue}`;
  }else {
      if (!stringValue.startsWith('₩')) {
          if (stringValue.indexOf('.') !== -1) {
              stringValue = stringValue.replace(/0+$/, '');
              stringValue = stringValue.replace(/\.$/, '');
          }
      }
      // console.log('stringValue',stringValue);
      return ` ₩${stringValue}`;
  }
}

export function displaySetPrice(price,currentPrice) {
  if (price <= 0 || price === null || price === undefined || price === '') {
      // 유효하지 않은 값일 경우, 빈 문자열 반환
      return '';
  }

  // currentPrice의 소수점 자리수 계산
  const decimalPlaces = countDecimalPlaces(currentPrice);
  // console.log('currentPrice',currentPrice);
  // console.log('decimalPlaces',decimalPlaces);
  // price를 currentPrice의 소수점 자리수에 맞게 포맷팅
  let formattedPrice = Number(price).toFixed(decimalPlaces);
  formattedPrice = formattedPrice.replace(/(\.\d*?[1-9])0+$|\.0*$/, '$1');

  return `${formattedPrice}`;
}

export function formatPriceChange(referenceValue, valueToFormat) {
  const numericReference = Number(referenceValue);
  let numericValueToFormat = Number(valueToFormat);

  if (isNaN(numericReference) || isNaN(numericValueToFormat)) {
      return valueToFormat;
  }

  const decimalPlaces = this.countDecimalPlaces(numericReference);
  let formattedValue = numericValueToFormat.toFixed(decimalPlaces);

  formattedValue = formattedValue.replace(/(\.\d*?[1-9])0+$|\.0*$/, '$1');

  return formattedValue;
}

function countDecimalPlaces(value) {
  if (!value) return 0; // 값이 없으면 0 반환

  const valueString = value.toString();
  // 소수점이 있는 경우, 소수점 뒷부분의 길이 반환
  if (valueString.indexOf('.') > -1) {
      return valueString.split('.')[1].length;
  }

  // 소수점이 없는 경우, 0 반환
  return 0;
}